import { Col, Row, TableColumnsType } from "antd";
import React, { useState } from "react";
import { useTheme } from "../../../Context/ThemeContext";
import { Utils } from "../../../../Utilities/Utils";
import { GSTTableType } from "./GSTReports";
import GSTR1SubModal from "./GSTR1SubModal";

const GSTR1 = ({
  gstTable4AReportsData,
  gstTable4BReportsData,
  gstTable5ReportsData,
  gstTable6AReportsData,
  gstTable6BReportsData,
  gstTable6CReportsData,
  gstTable7AReportsData,
  gstTable7BReportsData,
  gstTable8ReportsData,
}: any) => {
  const { themeData } = useTheme();
  const [subModalLoading, setSubModalLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>({});
  const disabledColAmount = {
    backgroundColor: "#a6a2a2",
  };
  const disabledCol = {
    backgroundColor: "grey",
  };
  const highlightedCol = {
    backgroundColor: "#fad6b9",
  };
  const highlightedTotalCol = {
    backgroundColor: "#f59d71",
    fontWeight: "bold",
  };
  const HeaderCol = {
    backgroundColor: themeData?.themeColor,
    color: "white",
  };
  const subHeadCol = {
    color: themeData?.themeColor,
    paddingLeft: "15px",
  };
  // console.log("gstTable4AReportsData: ", gstTable4AReportsData);
  // console.log("gstTable4BReportsData: ", gstTable4BReportsData);
  // console.log("gstTable5ReportsData: ", gstTable5ReportsData);
  // console.log("gstTable6AReportsData: ", gstTable6AReportsData);
  // console.log("gstTable6BReportsData: ", gstTable6BReportsData);
  console.log("gstTable6CReportsData: ", gstTable6CReportsData);
  // console.log("gstTable7AReportsData: ", gstTable7AReportsData);
  // console.log("gstTable7BReportsData: ", gstTable7BReportsData);
  // console.log("gstTable8ReportsData: ", gstTable8ReportsData);

  const handleRowClick = (
    tableType: GSTTableType,
    tableData1: any,
    tableData2?: any,
    filterType?: string
  ) => {
    if (
      (tableData1 && tableData1.length > 0) ||
      (tableData2 && tableData2.length > 0)
    ) {
      setTableData({
        tableType: tableType,
        tableData1: tableData1,
        tableData2: tableData2 ? tableData2 : null,
        filterType: filterType ? filterType : "",
      });
      setSubModalLoading(true);
    }
  };
  const sharedOnCell = (rec: any, index?: number) => {
    if (rec.rowType === 1) {
      return { colSpan: 0 };
    }
    return {};
  };
  const table4Columns: TableColumnsType<any> = [
    {
      title: "GSTIN of Suppliers",
      dataIndex: "rowType",
      key: "key",
      onCell: (record, index) => ({
        colSpan: record?.rowType === 1 ? 14 : 1,
      }),
      render: (_, record: any) =>
        record?.rowType === 1 ? (
          <p style={{ fontWeight: "bold" }}>{record?.partyGSTNo}</p>
        ) : (
          <>{record?.partyGSTNo}</>
        ),
    },
    {
      title: "Trade / Legal Name",
      dataIndex: "partyName",
      key: "partyName",
      onCell: sharedOnCell,
    },
    {
      title: "Invoice Details",
      children: [
        {
          title: "Number",
          dataIndex: "number",
          key: "number",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Type",
          dataIndex: "voucherType",
          key: "voucherType",
          onCell: sharedOnCell,
          render: (_, record: any) => <>{record?.voucherType}</>,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Value",
          dataIndex: "invoiceValue",
          key: "invoiceValue",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
    {
      title: "Place of Suppliers",
      dataIndex: "supplyState",
      key: "supplyState",
      onCell: sharedOnCell,
      render: (_: any, record: any) => <>{record?.supplyState}</>,
    },
    // {
    //   title: "Supply Attract Reverse Charge",
    //   dataIndex: "supply",
    //   key: "supply",
    //   onCell: sharedOnCell,
    //   render: (_: any, record: any) =>
    //     record.rowType !== 1 && (
    //       <>
    //         <p>No</p>
    //       </>
    //     ),
    // },
    {
      title: "Rate(%)",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "HSN/SAC",
      dataIndex: "hsnsac",
      key: "hsnsac",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "Taxable Value",
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      align: "right",
      onCell: sharedOnCell,
    },
    {
      title: "Tax Amount",

      children: [
        {
          title: "Integrated",
          dataIndex: "igstAmt",
          key: "igstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "Central",
          dataIndex: "cgstAmt",
          key: "cgstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "State/UT",
          dataIndex: "sgstAmt",
          key: "sgstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "Cess",
          dataIndex: "cessAmt",
          key: "cessAmt",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
  ];

  const table5Columns: TableColumnsType<any> = [
    {
      title: "Place of Supply (State/UT)",
      dataIndex: "rowType",
      key: "key",
      onCell: (record, index) => ({
        colSpan: record?.rowType === 1 ? 9 : 1,
      }),
      render: (_, record: any) =>
        record?.rowType === 1 ? (
          <p style={{ fontWeight: "bold" }}>{record?.supplyState}</p>
        ) : (
          <>{record?.supplyState}</>
        ),
    },
    {
      title: "Invoice Details",
      children: [
        {
          title: "Number",
          dataIndex: "number",
          key: "number",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Type",
          dataIndex: "voucherType",
          key: "voucherType",
          onCell: sharedOnCell,
          render: (_, record: any) => <>{record?.voucherType}</>,
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          align: "center",
          onCell: sharedOnCell,
        },
        {
          title: "Value",
          dataIndex: "invoiceValue",
          key: "invoiceValue",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
    {
      title: "Rate(%)",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "Taxable Value",
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      align: "right",
      onCell: sharedOnCell,
    },
    {
      title: "Tax Amount",

      children: [
        {
          title: "Integrated",
          dataIndex: "igstAmt",
          key: "igstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "Cess",
          dataIndex: "cessAmt",
          key: "cessAmt",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
  ];

  const table8Columns: TableColumnsType<any> = [
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Nil Rated Supplies",
      dataIndex: "nilRatedSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Exempted (Other than Nil rated / non-GST supplies)",
      dataIndex: "exemptedSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
    {
      title: "Non-GST Supplies",
      dataIndex: "nonGSTSupplies",
      width: "20%",
      align: "right",
      render: (val: any, record: any) => Utils.getFormattedNumber(val),
    },
  ];
  return (
    <>
      <Row justify={"center"}>
        <Col>
          <h3 style={{ textAlign: "center" }}>FORM GSTR-1</h3>
          <p style={{ textAlign: "center" }}>[See rule 59(1)]</p>
          <h4 style={{ textAlign: "center" }}>
            Details of outward supplies of goods or services
          </h4>
        </Col>
      </Row>
      <Row justify={"end"}>
        <Col>
          <table className="ca-gsttable">
            <tbody>
              <tr>
                <td style={highlightedCol}>Financial Year</td>
                <td>2024-25</td>
              </tr>
              <tr>
                <td style={highlightedCol}>Tax Period</td>
                <td>February</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <Row>
        <Col>
          <table className="ca-gsttable">
            <tbody>
              <tr>
                <td>(1)</td>
                <td colSpan={2} style={highlightedCol}>
                  GSTIN
                </td>
                <td>GST No.</td>
              </tr>
              <tr>
                <td rowSpan={4}>(2)</td>
                <td style={highlightedCol}>(a)</td>
                <td style={highlightedCol}>
                  Legal name of the registered person
                </td>
                <td>Business Name</td>
              </tr>
              <tr>
                <td style={highlightedCol}>(b)</td>
                <td style={highlightedCol}>Trade name if any</td>
                <td>Business Name</td>
              </tr>
              {/* <tr>
              <td>(c)</td>
              <td>ARN</td>
              <td>ARN No.</td>
            </tr>
            <tr>
              <td>(d)</td>
              <td>ARN Date</td>
              <td>01/02/2025</td>
            </tr> */}
            </tbody>
          </table>
        </Col>
      </Row>
      <Row>
        <Col>
          <table className="ca-gsttable">
            <thead>
              <tr style={HeaderCol}>
                <th style={{ padding: "6px" }}>Description</th>
                <th style={{ padding: "6px" }}>No. of records</th>
                <th style={{ padding: "6px" }}>Document Type</th>
                <th style={{ width: "12%", padding: "6px" }} align="right">
                  Taxable Value (₹)
                </th>
                <th style={{ width: "10%", padding: "6px" }} align="right">
                  Integrated Tax (₹)
                </th>
                <th style={{ width: "10%", padding: "6px" }} align="right">
                  Central Tax (₹)
                </th>
                <th style={{ width: "10%", padding: "6px" }} align="right">
                  State/UT Tax (₹)
                </th>
                <th style={{ width: "10%", padding: "6px" }} align="right">
                  Cess (₹)
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Table 4A - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  4A - Taxable outward supplies made to registered persons
                  (other than reverse charge supplies) including supplies made
                  through e-commerce operator attracting TCS - B2B Regular
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_4A, gstTable4AReportsData)
                }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable4AReportsData
                    ? gstTable4AReportsData?.filter(
                        (rec: any) => rec.rowType === 0
                      )?.length
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {gstTable4AReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4AReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.taxableAmount : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right">
                  {" "}
                  {gstTable4AReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4AReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.igstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right">
                  {" "}
                  {gstTable4AReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4AReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.cgstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right">
                  {" "}
                  {gstTable4AReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4AReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.sgstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right">
                  {" "}
                  {gstTable4AReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4AReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.cessAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>
              {/* Table 4B - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  4B - Taxable outward supplies made to registered persons
                  attracting tax on reverse charge - B2B Reverse charge
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_4B, gstTable4BReportsData)
                }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable4BReportsData
                    ? gstTable4BReportsData?.filter(
                        (rec: any) => rec.rowType === 0
                      )?.length
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {" "}
                  {gstTable4BReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4BReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.taxableAmount : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right" style={disabledColAmount}>
                  {gstTable4BReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4BReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.igstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right" style={disabledColAmount}>
                  {gstTable4BReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4BReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.cgstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right" style={disabledColAmount}>
                  {gstTable4BReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4BReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.sgstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right" style={disabledColAmount}>
                  {gstTable4BReportsData
                    ? Utils.getFormattedNumber(
                        gstTable4BReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.cessAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>
              {/* Table 5 - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  5 - Taxable outward inter-state supplies made to unregistered
                  persons (where invoice value is more than Rs. 1 lakh)
                  including supplies made through e-commerce operator, rate wise
                  - B2CL (Large)
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_5A, gstTable5ReportsData)
                }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable5ReportsData
                    ? gstTable5ReportsData?.filter(
                        (rec: any) => rec.rowType === 0
                      )?.length
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {gstTable5ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable5ReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.taxableAmount : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right">
                  {gstTable5ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable5ReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.igstAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">
                  {" "}
                  {gstTable5ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable5ReportsData?.reduce(
                          (acc: number, rec: any) =>
                            acc + (rec.rowType === 0 ? rec.cessAmt : 0),
                          0
                        )
                      )
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>
              {/* Table 6A - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  6A – Exports (with/without payment)
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(GSTTableType.GSTR1_6A, gstTable6AReportsData)
                // }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable6AReportsData?.total?.totalRecords
                    ? gstTable6AReportsData?.total?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6AReportsData?.total?.totalTaxableValue
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6AReportsData?.total?.totalIGST
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(
                //     GSTTableType.GSTR1_6A,
                //     gstTable6AReportsData,
                //     null,
                //     "EXPWP"
                //   )
                // }
              >
                <td style={{ paddingLeft: "15px" }}>- EXPWP</td>
                <td align="center">
                  {gstTable6AReportsData?.exWP?.totalRecords
                    ? gstTable6AReportsData?.exWP?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6AReportsData?.exWP?.totalTaxableValue
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6AReportsData?.exWP?.totalIGST
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(
                //     GSTTableType.GSTR1_6A,
                //     gstTable6AReportsData,
                //     null,
                //     "EXPWOP"
                //   )
                // }
              >
                <td style={{ paddingLeft: "15px" }}>- EXPWOP</td>
                <td align="center">
                  {gstTable6AReportsData?.exWOP?.totalRecords
                    ? gstTable6AReportsData?.exWP?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6AReportsData?.exWOP?.totalTaxableValue
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 6B - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  6B - Supplies made to SEZ unit or SEZ developer - SEZWP/SEZWOP
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(GSTTableType.GSTR1_6B, gstTable6BReportsData)
                // }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable6BReportsData?.total?.totalRecords
                    ? gstTable6BReportsData?.total?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6BReportsData?.total?.totalTaxableValue
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6BReportsData?.total?.totalIGST
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(
                //     GSTTableType.GSTR1_6B,
                //     gstTable6BReportsData,
                //     null,
                //     "SEZWP"
                //   )
                // }
              >
                <td style={{ paddingLeft: "15px" }}>- SEZWP</td>
                <td align="center">
                  {gstTable6BReportsData?.exWP?.totalRecords
                    ? gstTable6BReportsData?.exWP?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6BReportsData?.exWP?.totalTaxableValue
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6BReportsData?.exWP?.totalIGST
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(
                //     GSTTableType.GSTR1_6B,
                //     gstTable6BReportsData,
                //     null,
                //     "SEZWOP"
                //   )
                // }
              >
                <td style={{ paddingLeft: "15px" }}>- SEZWOP</td>
                <td align="center">
                  {gstTable6BReportsData?.exWOP?.totalRecords
                    ? gstTable6BReportsData?.exWP?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6BReportsData?.exWOP?.totalTaxableValue
                  )}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 6C - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  6C - Deemed Exports – DE
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                // onClick={() =>
                //   handleRowClick(GSTTableType.GSTR1_6C, gstTable6CReportsData)
                // }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable6CReportsData?.totalRecords
                    ? gstTable6CReportsData?.totalRecords
                    : 0}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable6CReportsData?.totalTaxableValue
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(gstTable6CReportsData?.totalIGST)}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(gstTable6CReportsData?.totalCGST)}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(gstTable6CReportsData?.totalSGST)}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(gstTable6CReportsData?.totalCess)}
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 7 - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  7- Taxable supplies (Net of debit and credit notes) to
                  unregistered persons (other than the supplies covered in Table
                  5) including supplies made through e-commerce operator
                  attracting TCS - B2CS (Others)
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(
                    GSTTableType.GSTR1_7A,
                    gstTable7AReportsData,
                    gstTable7BReportsData
                  )
                }
              >
                <td>Total</td>
                <td align="center">
                  {gstTable7BReportsData?.reduce(
                    (acc: number, rec: any) =>
                      acc + (rec.rowType === 1 ? rec.totalCount : 0),
                    0
                  ) +
                    gstTable7AReportsData?.reduce(
                      (acc: number, rec: any) => acc + rec.totalCount,
                      0
                    )}
                </td>
                <td align="center">Invoice</td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable7BReportsData?.reduce(
                      (acc: number, rec: any) =>
                        acc + (rec.rowType === 0 ? rec.taxableValue : 0),
                      0
                    ) +
                      gstTable7AReportsData?.reduce(
                        (acc: number, rec: any) => acc + rec.taxableValue,
                        0
                      )
                  )}
                </td>
                <td align="right">
                  {Utils.getFormattedNumber(
                    gstTable7BReportsData?.reduce(
                      (acc: number, rec: any) =>
                        acc + (rec.rowType === 0 ? rec.igstAmt : 0),
                      0
                    ) +
                      gstTable7AReportsData?.reduce(
                        (acc: number, rec: any) => acc + rec.igstAmt,
                        0
                      )
                  )}
                </td>
                <td align="right">
                  {" "}
                  {Utils.getFormattedNumber(
                    gstTable7BReportsData?.reduce(
                      (acc: number, rec: any) =>
                        acc + (rec.rowType === 0 ? rec.cgstAmt : 0),
                      0
                    ) +
                      gstTable7AReportsData?.reduce(
                        (acc: number, rec: any) => acc + rec.cgstAmt,
                        0
                      )
                  )}
                </td>
                <td align="right">
                  {" "}
                  {Utils.getFormattedNumber(
                    gstTable7BReportsData?.reduce(
                      (acc: number, rec: any) =>
                        acc + (rec.rowType === 0 ? rec.sgstAmt : 0),
                      0
                    ) +
                      gstTable7AReportsData?.reduce(
                        (acc: number, rec: any) => acc + rec.sgstAmt,
                        0
                      )
                  )}
                </td>
                <td align="right">
                  {" "}
                  {Utils.getFormattedNumber(
                    gstTable7BReportsData?.reduce(
                      (acc: number, rec: any) =>
                        acc + (rec.rowType === 0 ? rec.cessAmt : 0),
                      0
                    ) +
                      gstTable7AReportsData?.reduce(
                        (acc: number, rec: any) => acc + rec.cessAmt,
                        0
                      )
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 8 - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  8 - Nil rated, exempted and non GST outward supplies
                </td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_8, gstTable8ReportsData)
                }
              >
                <td colSpan={3}>Total</td>
                <td align="right">
                  {gstTable8ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable8ReportsData.reduce(
                          (acc: number, rec: any) =>
                            acc +
                            (rec.nilRatedSupplies +
                              rec.nonGSTSupplies +
                              rec.exemptedSupplies),
                          0
                        )
                      )
                    : Utils.getFormattedNumber(0)}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_8, gstTable8ReportsData)
                }
              >
                <td colSpan={3} style={{ paddingLeft: "15px" }}>
                  - Nil
                </td>
                <td align="right">
                  {" "}
                  {gstTable8ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable8ReportsData.reduce(
                          (acc: number, rec: any) => acc + rec.nilRatedSupplies,
                          0
                        )
                      )
                    : Utils.getFormattedNumber(0)}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_8, gstTable8ReportsData)
                }
              >
                <td colSpan={3} style={{ paddingLeft: "15px" }}>
                  - Exempted
                </td>
                <td align="right">
                  {" "}
                  {gstTable8ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable8ReportsData.reduce(
                          (acc: number, rec: any) => acc + rec.exemptedSupplies,
                          0
                        )
                      )
                    : Utils.getFormattedNumber(0)}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleRowClick(GSTTableType.GSTR1_8, gstTable8ReportsData)
                }
              >
                <td colSpan={3} style={{ paddingLeft: "15px" }}>
                  - Non-GST
                </td>
                <td align="right">
                  {" "}
                  {gstTable8ReportsData
                    ? Utils.getFormattedNumber(
                        gstTable8ReportsData.reduce(
                          (acc: number, rec: any) => acc + rec.nonGSTSupplies,
                          0
                        )
                      )
                    : Utils.getFormattedNumber(0)}
                </td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 9B CDNR - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  9B - Credit/Debit Notes (Registered) – CDNR
                </td>
              </tr>
              <tr>
                <td>
                  Total - Net off debit/credit notes (Debit notes - Credit
                  notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8} style={subHeadCol}>
                  Credit / Debit notes issued to registered person for taxable
                  outward supplies in table 4 other than table 6 - B2B Regular
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>
                  Net Total (Debit notes – Credit notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8} style={subHeadCol}>
                  Credit / Debit notes issued to registered person for taxable
                  outward supplies in table 4 other than table 6 - B2B Reverse
                  charge{" "}
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>
                  Net Total (Debit notes – Credit notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
              </tr>
              <tr>
                <td colSpan={8} style={subHeadCol}>
                  Credit / Debit notes issued to registered person for taxable
                  outward supplies in table 6B - SEZWP/SEZWOP{" "}
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>
                  Net Total (Debit notes – Credit notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8} style={subHeadCol}>
                  Credit / Debit notes issued to registered person for taxable
                  outward supplies in table 6C – DE{" "}
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>
                  Net Total (Debit notes – Credit notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 9B CDNUR - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  9B - Credit/Debit Notes (Unregistered) – CDNUR
                </td>
              </tr>
              <tr>
                <td>
                  Total - Net off debit/credit notes (Debit notes - Credit
                  notes)
                </td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8} style={{ paddingLeft: "15px" }}>
                  Unregistered Type
                </td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>- B2CL</td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>- EXPWP</td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "30px" }}>- EXPWP</td>
                <td align="center">0</td>
                <td align="center">Note</td>
                <td align="right">0.00</td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
                <td align="right" style={disabledCol}></td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 11A(1), 11A(2) - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  11A(1), 11A(2) - Advances received for which invoice has not
                  been issued (tax amount to be added to the output tax
                  liability) (Net of refund vouchers, if any)
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td align="center">0</td>
                <td align="center">Net Value</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 11B(1), 11B(2) - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  11B(1), 11B(2) - Advance amount received in earlier tax period
                  and adjusted against the supplies being shown in this tax
                  period in Table Nos. 4, 5, 6 and 7 (Net of refund vouchers, if
                  any){" "}
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td align="center">0</td>
                <td align="center">Net Value</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 12 - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  12 - HSN-wise summary of outward supplies{" "}
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td align="center">0</td>
                <td align="center">NA</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Table 14 - Summary */}
              <tr>
                <td colSpan={8} style={highlightedCol}>
                  14 - Supplies made through E-Commerce Operators
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td align="center">0</td>
                <td align="center">Net Value</td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
                <td align="right" style={disabledColAmount}>
                  0.00
                </td>
              </tr>
              <tr>
                <td colSpan={8}>&nbsp;</td>
              </tr>{" "}
              {/* Total */}
              <tr style={highlightedTotalCol}>
                <td colSpan={3}>
                  Total Liability (Outward supplies other than Reverse charge)
                </td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
                <td align="right">0.00</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      {subModalLoading && (
        <GSTR1SubModal
          tableType={tableData?.tableType}
          tableData1={tableData?.tableData1}
          tableData2={tableData?.tableData2}
          filterType={tableData?.filterType}
          subModalLoading={subModalLoading}
          setSubModalLoading={setSubModalLoading}
        />
      )}
    </>
  );
  // return (
  //   <div>
  //     {/* GSTR-1 Tables */}
  //     {/* Table 4 */}
  //     {gstTable4ReportsData?.length > 0 &&
  //       <>
  //         <div style={{ width: "100%", margin: "0 auto" }}>
  //           <h4 style={{ padding: "5px", borderRadius: 5, color: `${themeData?.themeColor}`, marginTop: "10px", marginBottom: "2px", backgroundColor: `${themeData?.themeColor}10` }}>Table 4: Taxable outward supplies made to registered persons (including UIN-holders) or, in other words, B2B supplies</h4>
  //           <Table
  //             bordered
  //             dataSource={gstTable4ReportsData}
  //             pagination={false}
  //             size="small"
  //             style={{ marginBottom: "30px" }}
  //             columns={table4Columns}
  //             // className="ca-viewmodel-table"
  //             className={`ca-viewmodel-table Tabel-style table-${themeData?.componentSize ?? "middle"
  //               }`}
  //             scroll={
  //               gstTable4ReportsData?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
  //             }
  //           />
  //         </div>
  //       </>
  //     }

  //     {/* Table 5 */}
  //     {gstTable5ReportsData?.length > 0 &&
  //       <>
  //         <div style={{ width: "100%", margin: "0 auto" }}>
  //           <h4 style={{ padding: "5px", borderRadius: 5, color: `${themeData?.themeColor}`, marginTop: "10px", marginBottom: "2px", backgroundColor: `${themeData?.themeColor}10` }}>Table 5: Taxable outward inter-state supplies to unregistered persons, in other words, B2C supplies, where the invoice value is more than Rs. 1 lakh</h4>
  //           <Table
  //             bordered
  //             dataSource={gstTable5ReportsData}
  //             pagination={false}
  //             size="small"
  //             style={{ marginBottom: "30px" }}
  //             columns={table5Columns}
  //             // className="ca-viewmodel-table"
  //             className={`ca-viewmodel-table Tabel-style table-${themeData?.componentSize ?? "middle"
  //               }`}
  //             scroll={
  //               gstTable5ReportsData?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
  //             }
  //           />
  //         </div>
  //       </>
  //     }
  //     {/* Table 7 */}
  //     {(gstTable7AReportsData?.length > 0 || gstTable7BReportsData?.length > 0) &&
  //       <>
  //         <div style={{ width: "100%", margin: "0 auto" }}>
  //           <h4 style={{ padding: "5px", borderRadius: 5, color: `${themeData?.themeColor}`, marginTop: "10px", marginBottom: "20px", backgroundColor: `${themeData?.themeColor}10` }}>Table 7 : A rate wise summary of all B2C sales made during the month/quarter where invoice value is less than Rs.2.5 lakhs</h4>
  //           <table className="ca-viewmodel-table" style={{ width: "100%", borderCollapse: "collapse", margin: "3px auto" }}>
  //             <thead >
  //               <tr>
  //                 <th rowSpan={2}>Rate of Tax</th>
  //                 <th rowSpan={2}>Total Taxable Value</th>
  //                 <th colSpan={4}>Amount</th>
  //               </tr>
  //               <tr>
  //                 <th>Integrated</th>
  //                 <th>Central</th>
  //                 <th>State/UT</th>
  //                 <th>Cess</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               <tr>
  //                 <td style={{ padding: "2px 4px", fontWeight: "bold" }} colSpan={6}>7A. Intra-State supplies - Consolidated rate wise outward supplies [including supplies made through e-commerce operator attracting TCS] </td>
  //               </tr>
  //               {gstTable7AReportsData?.map((r: any, rIndex: number) => (<tr>
  //                 <td align="center" style={{ padding: "2px 4px" }}>{`${r?.taxRate}%`}</td>
  //                 <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.taxableValue)}</td>
  //                 <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.igstAmt)}</td>
  //                 <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.cgstAmt)}</td>
  //                 <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.sgstAmt)}</td>
  //                 <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.cessAmt)}</td>
  //               </tr>))}
  //               <tr>
  //                 <td style={{ padding: "2px 4px", fontWeight: "bold" }} colSpan={6}>7B. Inter-State Supplies where invoice value is upto Rs. 2.5 lakh - Consolidated rate wise outward supplies [including supplies made through e-commerce operator attracting TCS]</td>
  //               </tr>
  //               {
  //                 gstTable7BReportsData?.map((r: any, rIndex: number) => (<tr>
  //                   {r?.rowType === 1 ? <td colSpan={6} style={{ padding: "2px 4px" }}><u>{`${r?.supplyState}`}</u></td> :
  //                     <>
  //                       <td align="center" style={{ padding: "2px 4px" }}>{`${r?.taxRate}%`}</td>
  //                       <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.taxableValue)}</td>
  //                       <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.igstAmt)}</td>
  //                       <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.cgstAmt)}</td>
  //                       <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.sgstAmt)}</td>
  //                       <td align="right" style={{ padding: "2px 4px" }}>{Utils.getFormattedNumber(r?.cessAmt)}</td>
  //                     </>
  //                   }
  //                 </tr>))
  //               }
  //             </tbody>
  //           </table>
  //         </div>
  //       </>
  //     }
  //     {/* Table 8 */}
  //     {gstTable8ReportsData?.length > 0 &&
  //       <>
  //         <div style={{ width: "100%", marginTop: "30px" }}>
  //           <h4 style={{ padding: "5px", borderRadius: 5, color: `${themeData?.themeColor}`, marginTop: "10px", marginBottom: "2px", backgroundColor: `${themeData?.themeColor}10` }}>Table 8: Nil-rated, exempt and non-GST outward supplies</h4>
  //           <Table
  //             bordered
  //             dataSource={gstTable8ReportsData}
  //             pagination={false}
  //             size="small"
  //             style={{ marginBottom: "30px" }}
  //             columns={table8Columns}
  //             // className="ca-viewmodel-table"
  //             className={`ca-viewmodel-table Tabel-style table-${themeData?.componentSize ?? "middle"
  //               }`}
  //           // scroll={
  //           //   gstTable8ReportsData?.length > 15 ? { x: 700, y: 620 } : { x: 600 }
  //           // }
  //           />
  //         </div>
  //       </>
  //     }
  //   </div >
  // );
};

export default GSTR1;
